export const blockIconsTransportationDirectionsSubwayNew = (
	<span className='material-symbols-outlined'>directions_subway</span>
);
